import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Text, TranslatedText } from '@pmu/tornado';

import { isUserAuthenticatedWithAcceptedCGUs as isUserAuthenticatedWithAcceptedCGUsSelector } from '@api/services/user';
import { S3_ASSETS_URL } from '@config/urls';
import { useAppSelector } from '@store/hooks';

import './index.scss';

const legalNoticeURL = `${S3_ASSETS_URL}/pdf/CGU_infocentre_FR_EN.pdf`;
const cookiesNoticeURL = `${S3_ASSETS_URL}/pdf/Cookie_management_policy_EN_FR.pdf`;
const privacyPolicyURL = `${S3_ASSETS_URL}/pdf/Privacy_policy_infocentre_EN_FR.pdf`;

const Footer = () => {
  const isUserAuthenticatedWithAcceptedCGUs = useAppSelector(
    isUserAuthenticatedWithAcceptedCGUsSelector
  );
  const [version, setVersion] = useState('');

  const cls = classNames({
    'is-notAuth': !isUserAuthenticatedWithAcceptedCGUs,
  });

  const isProduction = window.config.ENVIRONMENT === 'prd';

  useEffect(() => {
    const metaTagName = isProduction ? 'version' : 'version-full';
    const versionMeta = document.querySelector(`meta[name="${metaTagName}"]`);

    if (versionMeta) {
      const versionContent = versionMeta.getAttribute('content') ?? '';

      setVersion(versionContent);
    }
  }, []);

  return (
    <footer {...(cls && { className: cls })} data-testid="Footer/version">
      <a target="_blank" rel="noreferrer" href="https://www.pmu.fr">
        <img
          src={`/logo-PMU-${isUserAuthenticatedWithAcceptedCGUs ? 'color' : 'white'}.svg`}
          alt="PMU.fr"
          width="90"
        />
      </a>

      <Text size="m">
        {version}
        {window.ticketIdForDeployment}
      </Text>

      <a target="_blank" rel="noreferrer" href={legalNoticeURL}>
        <TranslatedText id="app.generic.legalNotice" />
      </a>
      <a target="_blank" rel="noreferrer" href={privacyPolicyURL}>
        <TranslatedText id="app.generic.privacyPolicy" />
      </a>
      <a target="_blank" rel="noreferrer" href={cookiesNoticeURL}>
        <TranslatedText id="app.generic.cookiesManagement" />
      </a>
    </footer>
  );
};

export { Footer };
